
const router_modular = [
    {
        path: '/home',
        name: 'home',
        component: () => import('@/views/HomeView')
    },
    {
        path: '/about',
        name: 'about',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '@/views/AboutView.vue')
    },
    {
        path: '/chenggong',
        name: 'chenggong',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '@/views/chenggongy.vue')
    },
    {
        path: '/Userhtml',
        name: 'Userhtml',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '@/views/Userhtml.vue')
    },
    {
        path: '/Privacyhtml',
        name: 'Privacyhtml',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '@/views/Privacyhtml.vue')
    },
    {
        path: '/Licensinghtml',
        name: 'Licensinghtml',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '@/views/Licensinghtml.vue')
    },
    {
        path: '/official',
        name: 'official',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '@/views/official.vue')
    },
    {
        path: '/zccg',
        name: 'zccg',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '@/views/zccg.vue')
    },
    {
        path: '/cuowu',
        name: 'cuowu',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '@/views/cuowu.vue')
    },
    {
        path: '/tuiguanggz',
        name: 'tuiguanggz',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '@/views/tuiguanggz.vue')
    },
    {
        path: '/tuiguanxy',
        name: 'tuiguanxy',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '@/views/tuiguanxy.vue')
    },
    {
        path: '/appDownloadLink',
        name: 'appDownloadLink',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '@/views/tiaozhuan.vue')
    },
    {
        path: '/PrivacyProtectionSummary',
        name: 'PrivacyProtectionSummary',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '@/views/xieyi/PrivacyProtectionSummary.vue')
    },
    {
        path: '/Scopeofsoftwarelicense',
        name: 'Scopeofsoftwarelicense',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '@/views/xieyi/Scopeofsoftwarelicense.vue')
    },
    {
        path: '/ProtectionGuidelines',
        name: 'ProtectionGuidelines',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '@/views/xieyi/ProtectionGuidelines.vue')
    },










]
export default router_modular